import React from 'react';
import { CheckCircle } from 'lucide-react';

export const ProgramPillars = ({ pillars }) => {
  return (
    <section id="program-details" className="section-padding container-padding section-gradient-light">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16 animate-fade-in-up">
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-gray-900">
            The <span className="gradient-text-green-purple">Four Pillars</span> of Transformation
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            A comprehensive, integrated approach to building your wellness industry authority
          </p>
        </div>

        {/* Pillars */}
        <div className="space-y-12">
          {pillars.map((pillar, index) => {
            const isEven = index % 2 === 0;
            
            return (
              <div
                key={index}
                className={`flex flex-col ${isEven ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-8 items-center animate-fade-in-up`}
              >
                {/* Image */}
                <div className="w-full lg:w-1/2">
                  <div className="relative rounded-2xl overflow-hidden shadow-2xl card-hover">
                    <img
                      src={pillar.image}
                      alt={pillar.title}
                      className="w-full h-80 object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                  </div>
                </div>

                {/* Content */}
                <div className="w-full lg:w-1/2">
                  <h3 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
                    {pillar.title}
                  </h3>
                  <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                    {pillar.description}
                  </p>
                  <ul className="space-y-3">
                    {pillar.outcomes.map((outcome, idx) => (
                      <li key={idx} className="flex items-start gap-3">
                        <CheckCircle className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" />
                        <span className="text-gray-700">{outcome}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
